import validator from "validator";
import { loadI18nValue } from "../../i18n";
export function isValidWebSocketURL(url: string): boolean {
    if(!url)return false;
    return validator.isURL(url, { protocols: ['ws','wss'], require_protocol: true });
  }
  

export enum SocketConnectStatusEnum {
    connecting = "connecting",
    connected = "connected",
    disconnecting = "disconnecting",
    disconnected = "disconnected",
    waitRetry = "waitRetry"
}

export async function getSocketConnectStatusEnumI18n(status:SocketConnectStatusEnum){
    return await loadI18nValue('fanfanlo/utils/socket/content', `status.${status}`);
}